import { Create } from 'react-admin'

import CommissionForm from './CommissionForm'

const CommissionCreate = props => (
  <Create redirect="list" {...props}>
    <CommissionForm isCreating permissions={props.permissions} />
  </Create>
)

export default CommissionCreate
